import e, { Component as t } from "react";
import n from "prop-types";
import r from "lodash.isempty";
import o from "date-fns";
import i from "styled-components";
function a(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function c(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function u(e) {
  return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function f(e, t) {
  return (f = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function s(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function l(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r,
      o,
      i = u(e);
    if (t) {
      var a = u(this).constructor;
      n = Reflect.construct(i, arguments, a);
    } else n = i.apply(this, arguments);
    return r = this, !(o = n) || "object" != typeof o && "function" != typeof o ? s(r) : o;
  };
}
function p(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function b(e) {
  return function (e) {
    if (Array.isArray(e)) return m(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return m(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === n && e.constructor && (n = e.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(e);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return m(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function m(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function d() {
  var e = p(["\n  border-radius: 5px;\n  height: 5px;\n  width: 5px;\n  ", ";\n"]);
  return d = function d() {
    return e;
  }, e;
}
function y() {
  var e = p(["\n  display: flex;\n  justify-content: space-between;\n"]);
  return y = function y() {
    return e;
  }, e;
}
function h() {
  var e = p(["\n  border-top: 1px solid #3b3b3b;\n  margin: 3px 0;\n"]);
  return h = function h() {
    return e;
  }, e;
}
function v() {
  var e = p(["\n  height: 27px;\n  margin-top: 6px;\n  margin-left: 6px;\n  transform: rotate(-25deg);\n  width: 27px;\n"]);
  return v = function v() {
    return e;
  }, e;
}
var g = function g(e, t, n) {
    var r = e.date,
      i = e.score,
      a = t.date,
      c = t.score,
      u = n.date,
      f = n.score,
      s = o.differenceInDays(u, a),
      l = f - c;
    return o.differenceInDays(r, a) * l - (i - c) * s > 0;
  },
  P = i.div(v()),
  w = i.hr(h()),
  O = i.div(y()),
  j = i.div(d(), function (e) {
    return e.on ? "background: #3b3b3b" : "";
  }),
  x = function (n) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && f(e, t);
    }(m, t);
    var o,
      i,
      u,
      p = l(m);
    function m() {
      var t;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, m);
      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) o[i] = arguments[i];
      return c(s(t = p.call.apply(p, [this].concat(o))), "getPoints", function (t, n) {
        return e.createElement(O, {
          className: "points"
        }, b(Array(n).keys()).map(function (n, r) {
          var o = t.includes(r);
          return e.createElement(j, {
            key: n,
            on: o,
            className: "point ".concat(o ? "on" : "")
          });
        }));
      }), c(s(t), "calculateAimlinePoints", function () {
        var e = t.props,
          n = e.startPoint,
          o = e.middlePoints,
          i = e.endPoint,
          a = e.isPointBelowAimline,
          c = {
            above: [],
            below: []
          };
        return !r(n) && !r(i) && n.score < i.score && o.forEach(function (e, t) {
          a(e, n, i) ? c.below.push(t) : c.above.push(t);
        }), c;
      }), t;
    }
    return o = m, (i = [{
      key: "render",
      value: function value() {
        var t = this.props.pointsMaxNumber,
          n = this.calculateAimlinePoints();
        return (!r(n.above) || !r(n.below)) && e.createElement(P, {
          className: "aimline"
        }, this.getPoints(n.above, t), e.createElement(w, null), this.getPoints(n.below, t));
      }
    }]) && a(o.prototype, i), u && a(o, u), m;
  }();
x.defaultProps = {
  pointsMaxNumber: 3,
  startPoint: {},
  middlePoints: [],
  endPoint: {},
  isPointBelowAimline: g
}, x.propTypes = {
  pointsMaxNumber: n.number,
  startPoint: n.shape({
    date: n.string,
    score: n.number
  }),
  middlePoints: n.arrayOf(n.shape({
    date: n.string,
    score: n.number
  })),
  endPoint: n.shape({
    date: n.string,
    score: n.number
  }),
  isPointBelowAimline: n.func
};
export { x as MiniAimline, g as isPointBelowLine };